(function ($) {
	'use strict'; 

	var $window = $(window);
	function why_choose_foursquare_counter_check_if_in_view() {
		$('.why-choose-foursquare__counter .counter_num').each(function(){
			if ($(this).hasClass('start')){
				var elementTop = $(this).offset().top;
				var elementBottom = elementTop + $(this).outerHeight();

				var viewportTop = $(window).scrollTop();
				var viewportBottom = viewportTop + $(window).height();

				if (elementBottom > viewportTop && elementTop < viewportBottom) {
						$(this).removeClass('start');
						$('.counter_num').text();
						var myNumbers = $(this).text();
						if (myNumbers == Math.floor(myNumbers)) {
							$(this).animate({
								Counter: $(this).text()
							}, {
								duration: 2800,
								easing: 'swing',
								step: function(now) {
									$(this).text(Math.ceil(now));                                
								}
							});
						} else {
							$(this).animate({
								Counter: $(this).text()
							}, {
								duration: 2800,
								easing: 'swing',
								step: function(now) {                                
									$(this).text(now.toFixed(1)); 
								}
							});
						} 
					}
			}
		});
	}

	$window.on('scroll', why_choose_foursquare_counter_check_if_in_view);
	$window.on('load', why_choose_foursquare_counter_check_if_in_view);

})(jQuery);
